import React from "react";
import TopicCard from "../TopicCard";

const RelatedTopicsSection = ({ title, topicsList, color = "purple", questionScreen }) => {
  return (
    <div className={`related-topics-section ${color || ""}`}>
      <div className="container">
        <h3>{title}</h3>
        <div className="related-topics-section__content">
          <ul className="topic-list flex">
            {topicsList?.map(item => (
              <TopicCard key={item.id} id={item.id} title={item.name} description={item.description} questionScreen={questionScreen} />
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default RelatedTopicsSection;
